<h2 mat-dialog-title>Edit reference</h2>

<div mat-dialog-content class="flex flex-column p2" style="gap: 0.5rem;">
  <div class="flex flex-column" style="gap: 0.5rem;">
    <div class="flex items-center">
      <mat-button-toggle-group
        class="ref-format-dialog__toggle"
        [value]="exportFormat()"
        (change)="onExportFormatChange($event.value)"
        aria-label="How this reference appears in the bibliography"
      >
        <mat-button-toggle value="auto">Generated</mat-button-toggle>
        <mat-button-toggle value="custom">Custom</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    @if (exportFormat() === 'auto') {
      <p class="muted">
        The bibliography is built from the reference details below (author, title, year, etc.). You
        can edit these fields; the final citation text is created when you export the document.
      </p>
    }
    @if (exportFormat() === 'custom') {
      <p class="muted">
        The bibliography will show exactly the text you enter below, instead of building it from the
        reference details. Use this when you need a specific wording or format for this reference.
      </p>
    }
  </div>

  @if (exportFormat() === 'auto') {
    @if (showEditor) {
      @if (data.reference.csl?._meta?.source === 'ai' && !data.reference.csl?._meta?.reviewed) {
        <sfo-admonition
          type="info"
          title="This reference was detected by AI. Please review the metadata below and correct any fields as needed."
          [hideToggle]="true"
        >
        </sfo-admonition>
      }
      @if (
        data.reference.csl?._meta?.source === 'plain-text' && !data.reference.csl?._meta?.reviewed
      ) {
        <sfo-admonition
          type="info"
          title="This reference was generated from plain text. Please review the metadata below and mark it as reviewed."
          [hideToggle]="true"
        >
        </sfo-admonition>
      }
      @if (showMissingPromotedFieldsPrompt()) {
        <sfo-admonition
          type="warning"
          title="This promoted plain-text reference is missing author and/or year. Fill those fields to keep bibliography ordering stable."
          [hideToggle]="true"
        >
        </sfo-admonition>
      }
      <sfo-reference-editor
        [reference]="currentReference()"
        (updateReference)="onReferenceUpdate($event)"
      ></sfo-reference-editor>
    }
  }

  @if (exportFormat() === 'custom') {
    <mat-form-field floatLabel="always" appearance="outline" class="col-12">
      <mat-label>Custom text</mat-label>
      <sfo-rich-text-input
        [ngModel]="customText()"
        (ngModelChange)="customText.set($event)"
        placeholder="Enter custom bibliography text"
        style="color:black"
      ></sfo-rich-text-input>
      <mat-hint
        >This text will be used for the bibliography reference instead of the auto-generated
        text.</mat-hint
      >
    </mat-form-field>
    @if (canResetCustomText()) {
      <div class="flex justify-end">
        <button mat-stroked-button type="button" (click)="resetCustomTextToDefault()">
          Reset to default
        </button>
      </div>
    }
  }
</div>

<div mat-dialog-actions align="end" class="flex items-center justify-end">
  @if (showReviewedCheckbox()) {
    <mat-checkbox
      class="mr2"
      [checked]="currentReference().csl?._meta?.reviewed === true"
      (change)="setReviewed($event.checked)"
      aria-label="Mark reference as reviewed"
    >
      Reviewed
    </mat-checkbox>
  }
  <span class="flex-1"></span>
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="save()">Apply changes</button>
</div>
